var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._l((_vm.testList),function(card){return _c('Card',{key:card.id,attrs:{"data":card,"statusList":_vm.statusList,"selected":_vm.selected},nativeOn:{"click":function($event){return _vm.selectCard(card.id)}}})}),_c('hr'),_c('Comparison',{attrs:{"data":_vm.comparisonData}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }